import { useQuery } from '@tanstack/react-query';

import getScheduleLiveAccount from 'Api/schedule/getScheduleLiveAccount';

import getAllAccountsResponse from './model/response/getAllAccountResponse';
import getScheduleLiveAccountPayload from './model/request/getScheduleLiveAccountPayload';

const useGetAllAccountLivestream = (filter = {}) =>
  useQuery({
    queryKey: ['all-account-livestream', filter],
    queryFn: async () => {
      const queries = getScheduleLiveAccountPayload(filter);
      
      const response = await getScheduleLiveAccount(queries);

      const result = getAllAccountsResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });

export default useGetAllAccountLivestream;
